import { log } from '../../util/log';
import type { BookingContext, SkinType } from '../../util/booking-context';
import { callWp } from '../../util/call-wp';
import { hideLoadingOverlay, showLoadingOverlay } from '../../util/loading-overlay';
import { loadChooseServicesPage } from './choose-services';
import { loadSelectLocationPage } from './select-location';
import { initCountdowns } from '../../util/countdown';
import { loadFindTimeslotPage } from './find-timeslot';

export async function loadFitzpatrickTestPage(context: BookingContext) {
	window.scroll(0, 0);
	log('Loading Fitzpatrick test page');
	// renderLoader(context);
	showLoadingOverlay(context);
	context.root.innerHTML = '';
	const ssrStartTime = performance.now();
	const ssrResponse = await callWp('GET', 'view_fitzpatrick_test', context.data);
	const ssrEndTime = performance.now();
	log('SSR took', ssrEndTime - ssrStartTime, 'ms');
	const html = ssrResponse.html;
	context.root.innerHTML = html;

	// for 1-6, get the data attribute data-image-url-1, data-image-url-2, etc
	// then set the src of the image to that url identitified by data-image-1, etc
	const image1 = context.root.querySelector<HTMLImageElement>('[data-image-1]');
	const image2 = context.root.querySelector<HTMLImageElement>('[data-image-2]');
	const image3 = context.root.querySelector<HTMLImageElement>('[data-image-3]');
	const image4 = context.root.querySelector<HTMLImageElement>('[data-image-4]');
	const image5 = context.root.querySelector<HTMLImageElement>('[data-image-5]');
	const image6 = context.root.querySelector<HTMLImageElement>('[data-image-6]');

	const image1Url = context.root.parentElement?.dataset['imageUrl-1'] ?? null;
	const image2Url = context.root.parentElement?.dataset['imageUrl-2'] ?? null;
	const image3Url = context.root.parentElement?.dataset['imageUrl-3'] ?? null;
	const image4Url = context.root.parentElement?.dataset['imageUrl-4'] ?? null;
	const image5Url = context.root.parentElement?.dataset['imageUrl-5'] ?? null;
	const image6Url = context.root.parentElement?.dataset['imageUrl-6'] ?? null;

	if (image1 && image1Url) {
		image1.src = image1Url;
	}
	if (image2 && image2Url) {
		image2.src = image2Url;
	}
	if (image3 && image3Url) {
		image3.src = image3Url;
	}
	if (image4 && image4Url) {
		image4.src = image4Url;
	}
	if (image5 && image5Url) {
		image5.src = image5Url;
	}
	if (image6 && image6Url) {
		image6.src = image6Url;
	}

	hideLoadingOverlay(context);

	context.root.querySelectorAll<HTMLButtonElement>('button[data-reload]').forEach((b) => b.addEventListener('click', () => loadFitzpatrickTestPage(context)));

	let fitzpatrickScore = 0;

	const inputs = context.root.querySelectorAll<HTMLInputElement | HTMLSelectElement>('[data-fitzpatrick-test]');
	const nextButton = context.root.querySelector<HTMLButtonElement>('[data-next]');

	inputs.forEach((input) => input.addEventListener('click', (e) => input?.nextElementSibling?.classList.contains('initial') ? inputs.forEach((inpt) => inpt?.nextElementSibling?.classList.remove('initial')) : ''));

	const recalculateFitzpatrickScore = () => {
		Array.from(inputs).forEach((e) => {});

		fitzpatrickScore = Array.from(inputs).reduce((score, input) => {
			if (isNaN(Number(input.value))) {
				return score;
			}

			if (input.type === 'radio') {
				if (!(input as HTMLInputElement).checked) {
					return score;
				}
			}

			return score + (Number(input.value) - 1);
		}, 0);

		fitzpatrickScore = fitzpatrickScore / 4;

		// Check if any of the values are 0, if so, disable the next button

		if (!nextButton) {
			return;
		}
		const skintoneScore = Array.from(inputs).reduce(
			(score, input) => (input.type === 'radio' && (input as HTMLInputElement).checked ? score + Number(input.value) : score),
			0
		);

		if (Array.from(inputs).some((input) => !input.value) || skintoneScore === 0) {
			nextButton.disabled = true;
		} else {
			nextButton.disabled = false;
		}
	};

	nextButton?.addEventListener('click', () => setSkinType(fitzpatrickScore >= 2.5 ? 'dark' : 'light', context));

	inputs.forEach((input) => input.addEventListener('change', recalculateFitzpatrickScore));

	const lightSkinButton = document.querySelector<HTMLButtonElement>('[data-skin-light]');
	const darkSkinButton = document.querySelector<HTMLButtonElement>('[data-skin-dark]');

	lightSkinButton?.addEventListener('click', () => setSkinType('light', context));
	darkSkinButton?.addEventListener('click', () => setSkinType('dark', context));
}

async function setSkinType(skinType: SkinType, context: BookingContext) {
	context.data.skinType = skinType;

	// This can just run in background, no need to wait for response
	void saveSkinType(skinType);

	// if (!context.data.locationId) {
	// 	return loadSelectLocationPage(context);
	// }

	return loadFindTimeslotPage(context);
}

async function saveSkinType(skinType: string) {
	const response = await callWp('POST', 'set_skin_type', { skinType });
	return response;
}
